/* @flow */
// $FlowIgnore
import { handleActions } from 'redux-actions';
import { fetchAuth } from '../utils/ajax';
import type { CallApi } from '../utils/ajax';

export type State = { isFetching: bool, isAuthorized: bool, user: Object, error?: Object }
export type Action = { type: string, payload: any }

let USER_REQUEST = 'gdc/USER_REQUEST';
let USER_SUCCESS = 'gdc/USER_SUCCESS';
let USER_FAILURE = 'gdc/USER_FAILURE';

let TOKEN_REQUEST = 'gdc/TOKEN_REQUEST';
let TOKEN_SUCCESS = 'gdc/TOKEN_SUCCESS';
let TOKEN_FAILURE = 'gdc/TOKEN_FAILURE';
let TOKEN_CLEAR = 'gdc/TOKEN_CLEAR';

export function fetchUser(): CallApi {
  return fetchAuth({
    types: [
      USER_REQUEST,
      {
        type: USER_SUCCESS,
        payload: async (action, state, res) => {
          let text = await res.text();
          let json = JSON.parse(text);
          return json;
        }
      },
      USER_FAILURE
    ],
    endpoint: 'user'
  });
}

export function forceLogout(): Action {
  return {
    type: USER_FAILURE,
    payload: { message: 'Session timed out or not authorized' }
  };
}

export function clearToken(): Action {
  return {
    type: TOKEN_CLEAR,
    payload: {}
  };
}

export function fetchToken(): CallApi {
  return fetchAuth({
    types: [
      TOKEN_REQUEST,
      {
        type: TOKEN_SUCCESS,
        payload: async (action, state, res) => {
          let text = await res.text();
          return text;
        }
      },
      TOKEN_FAILURE
    ],
    endpoint: 'token/refresh'
  });
}

let initialState: State = {
  firstLoad: true,
  isFetching: false,
  isAuthorized: false,
  user: {},
  error: {},
  isFetchingToken: false,
  token: undefined
};

export default handleActions({
  [USER_REQUEST]: (state) => ({
    ...state,
    isFetching: true,
    isAuthorized: false,
    user: {},
    error: {}
  }),
  [USER_SUCCESS]: (state, action) => ({
    ...state,
    isFetching: false,
    isAuthorized: Object.keys((action.payload.projects || {}).gdc_ids || {}).length > 0,
    user: action.payload,
    error: {},
    firstLoad: false,
  }),
  [USER_FAILURE]: (state, action) => ({
    ...state,
    isFetching: false,
    isAuthorized: false,
    error: action.payload,
    user: {},
    firstLoad: false,
  }),
  [TOKEN_REQUEST]: (state) => ({
    ...state,
    isFetchingToken: true
  }),
  [TOKEN_SUCCESS]: (state, action) => ({
    ...state,
    isFetchingToken: false,
    token: action.payload
  }),
  [TOKEN_FAILURE]: (state) => ({
    ...state,
    isFetchingToken: false,
    token: undefined,
  }),
  [TOKEN_CLEAR]: (state) => ({
    ...state,
    isFetchingToken: false,
    token: undefined,
  }),
}, initialState);
